/*
 * Copyright (c) 2024 Omnissa, Inc. All Rights Reserved.
 */
import { Component, NgZone } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ElementData } from "app/models/elementdata";
import { ProductReleases } from "app/models/productreleases";
import { VMwareProducts } from "app/models/vmwareproducts";
import { AlertService, AuthenticationService, AuthService, LimitsService, ReportsService } from "app/services";
import { ApiService } from "app/services/api.service";
import { Subscription } from "rxjs";
import { Globals } from '../common/globals';
import { NumberConstants } from "../common/numberconstants";
import { Location } from '../../../node_modules/@angular/common';
import { CategoriesRecord } from '../models/categoriesrecord';
import { TranslateService } from "@ngx-translate/core";
import { EnvironmentsService } from "app/services/enviornment.service";


@Component({
    styleUrls: ['./home.component.scss'],
    templateUrl: './home.component.html'
})

export class HomeComponent {
    private subscription: Subscription;
    title: string = "";
    transLang: any;
    collapsible: Boolean = true;
    collapsed: Boolean = false;
    productsRight: VMwareProducts[];
    versionsRight: ProductReleases[];
    maximumids: number[] = new Array();
    maximumSubids: number[] = new Array();
    selectedProduct: number;
    selectedObject: VMwareProducts;
    selectedVersion: any;
    products: any;
    versions: any;
    maximums: any;
    maxCat: number[] = new Array();
    maxSubCat: number[] = new Array();
    configMaxSubAttrs: any;
    loaded: boolean = false;
    totalRec: number;
    prodIdx = this.numberConstant.ZERO;
    versionIdx = this.numberConstant.ZERO;
    openModal: boolean = false;
    menuItems = [];
    isUserLoggedIn: any;
    configProduct: boolean = false;
    isExpanded: any = {};
    constructor(private zone: NgZone, private alertService: AlertService,
        private reportService: ReportsService, private limitsService: LimitsService, private globals: Globals, private router: Router,
        private route: ActivatedRoute, private numberConstant: NumberConstants, private translateService: TranslateService,private envService: EnvironmentsService
    ) {
    }

    ngOnInit() {
        this.subscription = this.route.queryParams.subscribe((params: Params) => {
            if (params['vmwareproduct']) {
                this.reportService.selectedBookmarkedprod = params["vmwareproduct"];
                this.reportService.selectedBookmarkedversion = params["release"];
                this.reportService.selectedBookmarkedCategories = params["categories"];
            }
        });

        this.reportService.categoriesArray = [];
        this.maxCat = [this.numberConstant.ZERO];
        this.maxSubCat = [this.numberConstant.ZERO];
        this.subscription = this.reportService.notifyObservable$.subscribe((res) => {
            if (res.hasOwnProperty('option') && res.option === 'click') {
                // perform your other action from here
                this.maximumids = this.reportService.maximumsCats1Selected;
                this.maximumSubids = this.reportService.maximumsSubCats1Selected;

            } else if (res.hasOwnProperty('option') && res.option === 'title') {
                this.title = res.value + this.translateService.instant('viewLimit.heading');
                this.reportService.selectedverName = res.value;
                this.maximumids = [];
                this.maximumSubids = [];
                this.maximums = [];
            }


        });
        this.getProductInConfigSet();

    }
    assignArray(type: String, expanded: boolean, rights: any[]): any[] {
        let arr = [{
            type: type,
            expanded: expanded,
            rights: rights,
            selected: false
        }];
        return arr;
    }

    getProductInConfigSet(): void {
        this.reportService.getProducts(null).subscribe(
            vmwareproducts => {
                let filteredProductsRight: Array<any> = [];
                vmwareproducts.forEach(vmwareprod => {
                    if(vmwareprod.support === true) { 
                        filteredProductsRight.push(vmwareprod);
                    }
                });
                this.productsRight = filteredProductsRight;
                // this.productsRight = vmwareproducts;
                if (this.productsRight != null && this.productsRight != undefined &&
                    this.productsRight.length > this.numberConstant.ZERO) {
                    //this.products.rights = this.productsRight;
                    this.selectedProduct = this.productsRight[this.numberConstant.ZERO].id;
                    this.selectedObject = this.productsRight[this.numberConstant.ZERO];
                    this.reportService.selectedprodID = this.productsRight[this.numberConstant.ZERO].id;
                    this.reportService.selectedprodName = this.productsRight[this.numberConstant.ZERO].rmVmwProduct;
                    this.isExpanded = {};
                    this.productsRight.forEach((ele)=>{
                        this.isExpanded[ele.id] = false;
                    })
                    var vmwareProducts: VMwareProducts;
                    this.products = this.assignArray(
                        "Select product",
                        true,
                        this.productsRight
                    );
                    this.reportService.selectedprodsInCfSet = vmwareproducts;
                    if (this.reportService.selectedBookmarkedprod != undefined) {
                        this.selectedProduct = this.reportService.selectedprodID;
                        for (let i = this.numberConstant.ZERO; i < this.productsRight.length; i++) {
                            if (this.productsRight[i].rmVmwProduct == this.reportService.selectedBookmarkedprod) {
                                this.prodIdx = i;
                                this.reportService.selectedprodID = this.productsRight[i].id;
                                this.reportService.selectedprodName = this.productsRight[i].rmVmwProduct;
                                this.selectedProduct = this.productsRight[i].id;
                                this.reportService.selectedBookmarkedprod = "";
                                break;
                            }
                        }

                    }
                    this.getSelProductVersionsByID();
                }
            },
            err => {
                // Log errors if any
                console.log(err);
            }
        );
    }

    getSelProductVersionsByID(): void {
        this.reportService
            .getProductVersions(this.selectedProduct.toString(), this.numberConstant.HASCONFIGSETANDPUBLISHED)
            .subscribe(
                vmwareproductsVersions => {
                    this.zone.run(() => {
                            // <== added
                        // Filter here
                        let filteredVersionsRight: Array<any> = [];
                        vmwareproductsVersions.forEach(vmwareversion => {
                            if(vmwareversion.support === true) { 
                                filteredVersionsRight.push(vmwareversion);
                            }
                        });
                        this.versionsRight = filteredVersionsRight;
                        this.selectedVersion = this.versionsRight[this.numberConstant.ZERO];
                        this.selectedProduct = this.versionsRight[this.numberConstant.ZERO].id;
                        this.reportService.selectedversionID = this.selectedVersion.id;
                        this.versions = this.assignArray(
                            "Select Version",
                            true,
                            this.versionsRight
                        );
                        if (this.reportService.selectedBookmarkedversion.length > this.numberConstant.ZERO) {
                            for (let i = this.numberConstant.ZERO; i < this.versionsRight.length; i++) {
                                if (this.versionsRight[i].rmVmwPrdRelVersion == this.reportService.selectedBookmarkedversion) {
                                    this.versionIdx = i;
                                    this.selectedVersion = this.versionsRight[i];
                                    this.reportService.selectedversionID = this.versionsRight[i].id;
                                    this.reportService.selectedverName = this.versionsRight[i].rmVmwPrdRelVersion;
                                    this.reportService.selectedBookmarkedversion = "";
                                    break;
                                }
                            }
                        }
                        this.reportService.notifyOther({
                            option: "title",
                            value: this.selectedVersion.rmVmwPrdRelVersion
                        });
                        this.reportService.getSelectedConfigset();
                    });
                }, //Bind to view
                err => {
                    // Log errors if any
                    this.versions = this.assignArray(
                        "Select Version",
                        true,
                        []
                    );
                    this.maximums = this.assignArray(this.translateService.instant('allcategoriesLabel'), true, []);
                    this.configMaxSubAttrs = [];
                    this.totalRec = this.numberConstant.ZERO;
                    this.loaded = true;
                    console.log(err);
                }
            );
    }

    getSelectedProductVersions(): void {
        this.reportService.getProductVersions(this.selectedProduct.toString(), this.numberConstant.ONE) // Get all product release versions of a given product
            .subscribe(vmwareproductsVersions => {
                this.zone.run(() => { // <== added
                    this.reportService.selectedversions = vmwareproductsVersions;
                });
            }, //Bind to view
                err => {
                    // Log errors if any
                    console.log(err)
                });

    }

    onProdChange(id) {
        let productFiltered = new VMwareProducts();
        this.productsRight.forEach(product => {
            this.isExpanded[product.id]=false;
            if (product.id == id) {
                productFiltered = product;
                this.isExpanded[product.id]=true;
            }
        });
        this.selectedProduct = productFiltered.id;
        this.selectedObject = productFiltered;
        this.reportService.selectedprodID = productFiltered.id;
        this.reportService.selectedprodName = productFiltered.rmVmwProduct;
        this.getSelProductVersionsByID();
    }


    updateSelections(prod, vers) {
        this.configProduct = true;
        var routeid = `guest?vmwareproduct=${prod}&release=${vers}`;
        this.router.navigateByUrl(routeid);
    }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts